import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $isTableCellNode,
  $isTableNode,
  $isTableRowNode,
  TableCellHeaderStates,
} from '@lexical/table';
import { $isParagraphNode, LexicalNode, SELECTION_INSERT_CLIPBOARD_NODES_COMMAND } from 'lexical';
import { useEffect } from 'react';

import { parseColor } from '../../../utils';

const nodeOverrides = (node: LexicalNode): LexicalNode | null => {
  if ($isTableNode(node)) {
    node.setColWidths(undefined);
    const prevChildren = node.getChildren();
    const children = prevChildren.map(nodeOverrides).filter(Boolean);
    if (!children.length) return null;
    node.splice(0, prevChildren.length, children);
    return node;
  }
  if ($isTableRowNode(node)) {
    node.setHeight(undefined);
    const prevChildren = node.getChildren();
    const children = prevChildren.map(nodeOverrides).filter(Boolean);
    if (!children.length) return null;
    if (!children.some(node => $isTableCellNode(node) && node.getChildren().length > 0))
      return null;
    node.splice(0, prevChildren.length, children);
  }
  if ($isTableCellNode(node)) {
    if (node.getParent()?.getParent()?.getFirstChild() === node.getParent()) {
      if (node.getParent()?.getFirstChild() === node) {
        const [R, G, B] = parseColor(node.getBackgroundColor() ?? '#fff');
        const L = 0.299 * R + 0.587 * G + 0.114 * B;
        if (L < 230)
          node
            .getParent()
            ?.getChildren()
            .forEach(node => {
              if ($isTableCellNode(node)) node.setHeaderStyles(TableCellHeaderStates.ROW);
            });
      }
    } else {
      node.setHeaderStyles(TableCellHeaderStates.NO_STATUS);
    }
    node.setBackgroundColor(null);
    node.setVerticalAlign(null);
    node.setIndent(0);
    node.setWidth(undefined);
    const prevChildren = node.getChildren();
    const children = prevChildren.map(nodeOverrides).filter(Boolean);
    node.splice(0, prevChildren.length, children);
    return node;
  }
  if ($isParagraphNode(node)) {
    const prevChildren = node.getChildren();
    const children = prevChildren.map(nodeOverrides).filter(Boolean);
    if (!children.length) return null;
    node.splice(0, prevChildren.length, children);
    return node;
  }
  return node;
};

export const ClipboardPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      SELECTION_INSERT_CLIPBOARD_NODES_COMMAND,
      ({ selection, nodes }) => {
        nodes = nodes.map(nodeOverrides).filter(Boolean);
        selection.insertNodes(nodes);
        return true;
      },
      0
    );
  }, [editor]);

  return null;
};
